import React, { useState } from 'react';
const faqs = [{
  q: 'Comment est-ce que je reçois le matériel ?',
  a: 'Dès que votre paiement est validé, vous recevez un e-mail avec le lien de téléchargement immédiat.'
}, {
  q: 'Est-ce conforme aux programmes français ?',
  a: "Oui, tous les volumes sont alignés sur les programmes de l'Éducation Nationale 2024-2026."
}, {
  q: 'Est-ce un abonnement ?',
  a: "Non. C'est un paiement unique. Vous achetez le pack et il vous appartient à vie."
}, {
  q: 'Puis-je imprimer les documents ?',
  a: "Oui, tous les fichiers sont au format PDF haute résolution, optimisés pour l'impression."
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-bg-alt py-20 sm:py-24 px-4" data-id="element-74">
      <div className="max-w-3xl mx-auto" data-id="element-75">
        <div className="text-center mb-12" data-id="element-76">
          <h2 className="text-3xl sm:text-5xl font-serif font-black text-text-main" data-id="element-77">
            Questions Fréquentes (FAQ)
          </h2>
        </div>

        <div className="space-y-4" data-id="element-78">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className="bg-bg-main border border-border-light rounded-2xl overflow-hidden" data-id="element-79">
                <button className="w-full text-left px-6 py-5 flex items-center justify-between gap-4" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} data-id="element-80">
                  <span className="font-bold text-text-main text-lg" data-id="element-81">
                    {faq.q}
                  </span>
                  <span className={`text-2xl text-primary transition-transform ${isOpen ? 'rotate-45' : ''}`} data-id="element-82">
                    +
                  </span>
                </button>
                <div className={`px-6 overflow-hidden transition-all duration-300 ${isOpen ? 'max-h-96 pb-6 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-83">
                  <p className="text-text-sec text-base" data-id="element-84">{faq.a}</p>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}